// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="pre-terminate box">
  <sub-header header="\$ctrl.title"></sub-header>
    <form name="\$ctrl.loanPreTerminateForm">
      <form-section>
        <loan-pre-terminate
          max-values='\$ctrl.maxValues'
          payment-request='\$ctrl.paymentRequest'
          priority-amortization-ids='\$ctrl.amortizationIds'
          waive-request='\$ctrl.waiveRequest'
          official-receipt='\$ctrl.officialReceipt'
          collect-official-receipt='true'
          loan='\$ctrl.loan'
        >
        </loan-pre-terminate>
        <div class="buttons">
          <button class="btn btn-warning" ng-click="\$ctrl.redirectBack()">Cancel</button>
          <button class="btn btn-success" ng-click="\$ctrl.preTerminate()"
                  ng-disabled="!\$ctrl.loanPreTerminateForm.\$valid || !\$ctrl.loan">
            {{'pre-terminate' | translate:'LOAN'}}
          </button>
        </div>

        <div class="clearfix"></div>
      </form-section>
    </form>
</section>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/pre-terminate/loan-pre-terminate-by-cash.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;